
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js") );
			}, "route-users");
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/users/index.js
// module id = 6Q9k
// module chunks = 7